import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getObjectDefTrg, isLinkedField } from '../components/Utils/Utils';

const parseOptionsArray = (raw) => {
  try {
    const arr = Array.isArray(raw)
      ? raw
      : typeof raw === 'string'
      ? JSON.parse(raw)
      : raw || [];
    if (!Array.isArray(arr)) return [];
    return arr.map((o) => ({
      value: o?.value != null ? String(o.value) : '',
      display: o?.display ?? String(o?.value ?? ''),
      color: o?.color ?? null,
      icon: o?.icon ?? null,
      meta: o,
    }));
  } catch {
    return [];
  }
};
const findObjectDef = (objectsDefList, objectType) =>
  objectsDefList?.find(
    (o) => o?.key === objectType || o?.label === objectType
  ) || null;
const findFieldDefInObject = (objectDef, fieldName) =>
  objectDef?.objFormData?.find((f) => f?.attrName === fieldName) || null;
const getTypeOfField = (objectsDefList, objectType, fieldName) => {
  const obj = findObjectDef(objectsDefList, objectType);
  const f = findFieldDefInObject(obj, fieldName);
  return f?.type || null;
};
const getOptionsForField = (objectsDefList, objectType, fieldName) => {
  const obj = findObjectDef(objectsDefList, objectType);
  const f = findFieldDefInObject(obj, fieldName);
  return f?.options ?? null;
};
const toBool = (v, def = true) => {
  if (v == null) return def;
  if (typeof v === 'boolean') return v;
  const s = String(v).trim().toLowerCase();
  if (s === 'true' || s === '1') return true;
  if (s === 'false' || s === '0') return false;
  return def;
};

const parseJsonSafe = (s) => {
  try {
    if (!s) return null;
    const v = typeof s === 'string' ? JSON.parse(s) : s;
    return v && typeof v === 'object' ? v : null;
  } catch {
    return null;
  }
};

const isNumericType = (t) => {
  if (!t) return false;
  const k = String(t).toLowerCase();
  // adapte la liste si besoin
  return [
    'number',
    'percent',
    'bignumber',
    'bigmonetary',
    'progressbar',
    'formula',
  ].includes(k);
};
// export const useFieldDefOLD = ({
//   objectType,
//   fieldName,
//   node = null,
//   value,
// }) => {
//   const objectsDefList = useSelector((s) => s.objects.objectsDefList);

//   return useMemo(() => {
//     const objectDef = findObjectDef(objectsDefList, objectType);
//     const original = findFieldDefInObject(objectDef, fieldName);

//     if (!original) {
//       return {
//         isValid: false,
//         objectType,
//         fieldName,
//         raw: { objectDef: null, fieldObject: null },
//       };
//     }

//     // ---- valeurs "effectives" (peuvent être remplacées si parentValue)
//     let effType = getTypeOfField(objectsDefList, objectType, fieldName);
//     // let effType = original.type ?? null;
//     let effLabel = original.label ?? fieldName;
//     let effUnit = original.unit ?? '';
//     let effOpts = original.options ?? null;
//     let effIsMult = toBool(original.allowMultiple, false);
//     let effIsLink = isLinkedField(objectsDefList, objectType, fieldName);
//     let effValueTransform = original.valueTransform ?? null;
//     let effParsedValueTransform = parseJsonSafe(effValueTransform);
//     // console.log(
//     //   'field name = %s type %s= label =% unit=%',
//     //   fieldName,
//     //   effType,
//     //   effLabel,
//     //   effUnit
//     // );

//     // ---- indirection: formula parentValue → lire la def du champ cible
//     const isParentValue =
//       original.type === 'formula' && original.formulaType === 'parentValue';

//     if (isParentValue && original.formulaObject && original.formulaField) {
//       const tgtObj = findObjectDef(objectsDefList, original.formulaObject);
//       const tgtField = findFieldDefInObject(tgtObj, original.formulaField);
//       if (tgtField) {
//         effType = tgtField.type ?? effType;
//         // effLabel = tgtField.label ?? effLabel;
//         effUnit = tgtField.unit ?? effUnit;
//         effOpts = tgtField.options ?? effOpts;
//         effIsMult = toBool(tgtField.allowMultiple, effIsMult);
//         effIsLink = isLinkedField(
//           objectsDefList,
//           original.formulaObject,
//           original.formulaField
//         );
//         // hérite aussi du valueTransform si le parent en a un
//         if (tgtField.valueTransform) {
//           effValueTransform = tgtField.valueTransform;
//           effParsedValueTransform = parseJsonSafe(effValueTransform);
//         }
//       }
//     }

//     // options directes si list
//     const parsedOptions = effType === 'list' ? parseOptionsArray(effOpts) : [];

//     // options indirectes (cat1/cat2) si formula et listes
//     let optionsCat1 = null;
//     let optionsCat2 = null;
//     if (original.type === 'formula' && original.formulaObject) {
//       const { formulaObject, formulaCat1, formulaCat2 } = original;
//       if (
//         formulaCat1 &&
//         getTypeOfField(objectsDefList, formulaObject, formulaCat1) === 'list'
//       ) {
//         optionsCat1 = parseOptionsArray(
//           getOptionsForField(objectsDefList, formulaObject, formulaCat1)
//         );
//       }
//       if (
//         formulaCat2 &&
//         getTypeOfField(objectsDefList, formulaObject, formulaCat2) === 'list'
//       ) {
//         optionsCat2 = parseOptionsArray(
//           getOptionsForField(objectsDefList, formulaObject, formulaCat2)
//         );
//       }
//     }

//     // droits
//     const fieldCanWrite =
//       toBool(original.canWrite, true) &&
//       !toBool(original.readOnly, false) &&
//       original.type !== 'formula';
//     const nodeCanWrite = toBool(node?.data?.canWrite, true);
//     const canWrite = fieldCanWrite && nodeCanWrite;
//     // console.log(
//     //   'post field name = %s type %s= label =% unit=%',
//     //   fieldName,
//     //   effType,
//     //   effLabel,
//     //   effUnit
//     // );
//     return {
//       // 1) on conserve 100% du backend
//       ...original,

//       // 2) identifiants (ATTENTION: on garde le fieldName d’origine)
//       objectType,
//       fieldName,

//       // 3) drapeaux consolidés
//       isValid: true,
//       canWrite,
//       permissions: { fieldCanWrite, nodeCanWrite },

//       // 4) “valeurs effectives” après résolution d’un parentValue
//       type: effType,
//       label: effLabel,
//       unit: effUnit,
//       hasUnit: !!effUnit,
//       isMultiple: effIsMult,
//       isLinked: effIsLink,
//       parsedOptions,
//       optionsCat1,
//       optionsCat2,

//       // 5) transforms
//       valueTransform: effValueTransform || null, // string ou null
//       parsedValueTransform: effParsedValueTransform, // objet ou null
//       isNumericLike: isNumericType(effType), // utile au resolver

//       // 6) contexte pour useFieldValueResolver
//       context: {
//         wasFormulaResolved: Boolean(isParentValue), // ← attendu par le resolver
//       },

//       // accès brut utile
//       raw: { objectDef, fieldObject: original },
//     };
//   }, [objectsDefList, objectType, fieldName, value, node?.data?.canWrite]);
// };

// -----------------------------------------------------
const makeSelectFieldDef = (params) =>
  createSelector([(state) => state.objects.objectsDefList], (objectsDefList) =>
    getFieldDefCore(objectsDefList, params)
  );

export const useFieldDef = (params) => {
  const selector = useMemo(
    () => makeSelectFieldDef(params),
    [
      params.objectType,
      params.fieldName,
      params.node?.data?.canWrite,
      params.value,
    ]
  );
  return useSelector(selector);
};

// Minimal-change pure core version of your hook logic
// Assumes the helpers below are in scope (as in your file):
// - parseOptionsArray, findObjectDef, findFieldDefInObject,
//   getTypeOfField, getOptionsForField, toBool, parseJsonSafe, isNumericType
// And the imported util:
//   import { isLinkedField } from '../components/Utils/Utils';

export function getFieldDefCore(
  objectsDefList,
  { objectType, fieldName, node = null, value } = {}
) {
  const objectDef = findObjectDef(objectsDefList, objectType);
  const original = findFieldDefInObject(objectDef, fieldName);

  if (!original) {
    return {
      isValid: false,
      objectType,
      fieldName,
      raw: { objectDef: null, fieldObject: null },
    };
  }

  // ---- valeurs "effectives" (peuvent être remplacées si parentValue)
  let effObjectLabel = objectDef.label ?? objectType;
  let effType = getTypeOfField(objectsDefList, objectType, fieldName);
  let effLabel = original.label ?? fieldName;
  let effUnit = original.unit ?? '';
  let effOpts = original.options ?? null;
  let effIsMult = toBool(original.allowMultiple, false);
  let effIsLink = isLinkedField(objectsDefList, objectType, fieldName);
  let effValueTransform = original.valueTransform ?? null;
  let effParsedValueTransform = parseJsonSafe(effValueTransform);

  // (logs conservés pour “minimum changes”)
  // console.log(
  //   'field name = %s type %s= label =% unit=%',
  //   fieldName,
  //   effType,
  //   effLabel,
  //   effUnit
  // );

  // ---- indirection: formula parentValue → lire la def du champ cible
  const isParentValue =
    original.type === 'formula' && original.formulaType === 'parentValue';

  if (isParentValue && original.formulaObject && original.formulaField) {
    const tgtObj = findObjectDef(objectsDefList, original.formulaObject);
    const tgtField = findFieldDefInObject(tgtObj, original.formulaField);
    if (tgtField) {
      effType = tgtField.type ?? effType;
      // effLabel = tgtField.label ?? effLabel; // (conservé: on ne remplace pas le label)
      effUnit = tgtField.unit ?? effUnit;
      effOpts = tgtField.options ?? effOpts;
      effIsMult = toBool(tgtField.allowMultiple, effIsMult);
      effIsLink = isLinkedField(
        objectsDefList,
        original.formulaObject,
        original.formulaField
      );
      if (tgtField.valueTransform) {
        effValueTransform = tgtField.valueTransform;
        effParsedValueTransform = parseJsonSafe(effValueTransform);
      }
    }
  }

  if (effIsLink) {
    let objDefTarget = getObjectDefTrg(objectsDefList, objectType, fieldName);
    effType = objDefTarget.type;
  }

  // options directes si list
  const parsedOptions = effType === 'list' ? parseOptionsArray(effOpts) : [];

  // options indirectes (cat1/cat2) si formula et listes
  let optionsCat1 = null;
  let optionsCat2 = null;
  if (original.type === 'formula' && original.formulaObject) {
    const { formulaObject, formulaCat1, formulaCat2 } = original;
    if (
      formulaCat1 &&
      getTypeOfField(objectsDefList, formulaObject, formulaCat1) === 'list'
    ) {
      optionsCat1 = parseOptionsArray(
        getOptionsForField(objectsDefList, formulaObject, formulaCat1)
      );
    }
    if (
      formulaCat2 &&
      getTypeOfField(objectsDefList, formulaObject, formulaCat2) === 'list'
    ) {
      optionsCat2 = parseOptionsArray(
        getOptionsForField(objectsDefList, formulaObject, formulaCat2)
      );
    }
  }

  // droits
  const fieldCanWrite =
    toBool(original.canWrite, true) &&
    !toBool(original.readOnly, false) &&
    original.type !== 'formula';
  const nodeCanWrite = toBool(node?.data?.canWrite, true);
  const canWrite = fieldCanWrite && nodeCanWrite;

  // console.log(
  //   'post field name = %s type %s= label =% unit=%',
  //   fieldName,
  //   effType,
  //   effLabel,
  //   effUnit
  // );

  return {
    // 1) on conserve 100% du backend
    ...original,

    // 2) identifiants (ATTENTION: on garde le fieldName d’origine)
    objectType,
    effObjectLabel,
    fieldName,

    // 3) drapeaux consolidés
    isValid: true,
    canWrite,
    permissions: { fieldCanWrite, nodeCanWrite },

    // 4) “valeurs effectives” après résolution d’un parentValue
    type: effType,
    label: effLabel,
    unit: effUnit,
    hasUnit: !!effUnit,
    isMultiple: effIsMult,
    isLinked: effIsLink,
    parsedOptions,
    optionsCat1,
    optionsCat2,

    // 5) transforms
    valueTransform: effValueTransform || null, // string ou null
    parsedValueTransform: effParsedValueTransform, // objet ou null
    isNumericLike: isNumericType(effType), // utile au resolver

    // 6) contexte pour useFieldValueResolver
    context: {
      wasFormulaResolved: Boolean(isParentValue),
    },

    // accès brut utile
    raw: { objectDef, fieldObject: original },
  };
}
